/** @prettier */
import React, { useState, createContext, useContext } from 'react';

export const DataContext = createContext({});

function Tab({ id, children, setTabActive }) {
  const [, setActiveTabID] = useContext(DataContext);
  return (
    <div>
      <div
        onClick={() => {
          setTabActive(id);
          setActiveTabID(id);
        }}
      >
        {children}
      </div>
    </div>
  );
}
function TabPanel({ whenActive, children }) {
  const [activeTabID] = useContext(DataContext);
  return <div>{activeTabID === whenActive ? children : null}</div>;
}

function TabSwitcher(props) {
  const [activeTabID, setActiveTabID] = useState(props.activeTab || 'ea');
  return <DataContext.Provider value={[activeTabID, setActiveTabID]}>{props.children}</DataContext.Provider>;
}

const Tabs = {
  TabSwitcher,
  Tab,
  TabPanel,
};

export default Tabs;
